export default __webpack_public_path__ + "static/media/internGreen.b58432b5.svg";